__webpack_require__.p = "https://umciwms.in/newdashboard/";